// Utils
import formatString from '../../utils/format-string-by-pattern';

export const ERRORS = {
  'Код с обратной стороны карты должен состоять из трёх цифр':
    'The security code from the reverse side of the card should consist of three digits',
  'В номере карты допущены ошибки': 'This card number is invalid',
  'Введите имя': 'Enter the name on card',
  'Введите номер карты': 'Enter the card number',
  'Введите код с обратной стороны карты':
    'Enter the security code from the reverse side of the card',
  'Название карты': 'Name on card',
  'Карта просрочена или неверно указан срок действия':
    'This card has expired or the expiration date is invalid',
  'Недостаточно средств на карте': 'This card has insufficient funds',
  'Укажите месяц': 'Enter the expiration month',
  'Слишком мало символов': 'Too few characters',
  'Слишком много символов': 'Too many characters',
  'В имени допущены ошибки': 'This name on card value is invalid',
  'Некорректное значение года/месяца': 'Incorrect month/year value',
  'Укажите год/месяц': 'Enter month/year',
};

export const translateErrors = (text, locale) => {
  if (locale === 'ru') {
    return text;
  }

  return ERRORS[text] !== undefined ? ERRORS[text] : text;
};

export const formatOnlyNumbers = (mask, anyString) => {
  const onlyNumbers = anyString.replace(/[^\d]/g, '');

  return formatString(mask, onlyNumbers);
};

export const formatDate = value => {
  const formatValue = value.replace(/[^\d]/g, '');

  let month = formatValue.substring(0, 2);
  let year = formatValue.substring(2, 4);

  if (month.length === 1 && month > 1) {
    month = `0${month}`;
  } else if (month.length === 2) {
    if (Number(month) === 0) {
      month = '01';
    } else if (month > 12) {
      month = '12';
    }
  }

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear().toString().substring(2);

  if (year.length === 1 && year < currentYear[0]) {
    year = '';
  } else if (year.length === 2) {
    if (year[0] < currentYear[0]) {
      year = currentYear;
    }

    if (year <= currentYear) {
      const currentMonth = currentDate.getMonth();

      year = Number(month) < currentMonth ? Number(currentYear) + 1 : currentYear;
    }
  }
  return formatString('99/99', month + year);
};

export const formatUppercase = value => value && value.toUpperCase();
